import React, { type ReactNode } from "react";
import { Box, Typography } from "@mui/material";
import {
  publicInfoCtaPanelSx,
  publicInfoCtaPanelTitleSx
} from "./constants/publicInfoPageStyles";

type PublicInfoCtaPanelProps = {
  title: string;
  children: ReactNode;
  testId?: string;
};

const PublicInfoCtaPanel: React.FC<PublicInfoCtaPanelProps> = ({
  title,
  children,
  testId
}) => (
  <Box component="section" sx={publicInfoCtaPanelSx} data-testid={testId}>
    <Typography component="h2" sx={publicInfoCtaPanelTitleSx}>
      {title}
    </Typography>
    {children}
  </Box>
);

export default PublicInfoCtaPanel;
